import { HostListener, Injectable } from '@angular/core';
import { StackingPlanService } from '../../../stacking-plan.service';
import { Executable } from '../executable';
import { NotificationService } from '../../../shared/services/notification.service';
import { filter } from 'rxjs';
import { SettingComponent } from './settings.component';
import { Settings } from './settings.model';
import { SettingsService } from './settings.service';

/**
 * Represents a directive that handles the export functionality.
 */
@Injectable()
export class SettingsExecutableService implements Executable {
  constructor(
    private notificationService: NotificationService,
    private stackingPlanService: StackingPlanService,
    private settingsService: SettingsService
  ) {}

  @HostListener('click', ['$event'])
  execute(): void {
    this.notificationService
      .openDialog(SettingComponent, this.settingsService.getSettings(), { panelClass: 'alert-modals' })
      .pipe(filter(Boolean))
      .subscribe((settingsData: Settings) =>
        this.stackingPlanService
          .saveSettings(settingsData)
          .subscribe(() => this.settingsService.setSettings(settingsData))
      );
  }
}
